import React from 'react';
import { shape, string } from 'prop-types';
import { sizes, Typography, SpacingContainer } from '@hyphengroup/cag-components';
import Heading from './Heading';
import Icon from './Icon';

const FormHeadingCompact = ({
  title,
  subTitle,
  description,
  requiredFields,
  className,
}) => (
  <div>
    <div className="layout-row">
      <div className={`${requiredFields.message ? 'column-md-7' : 'column-md-12'} layout-column`}>
        <Heading primary as="h1" className={className}>
          {title}
        </Heading>
        { subTitle && (
          <SpacingContainer marginBottom={[sizes(3), '0']}>
            <Typography variant="secondary" as="h4" align={['left', 'left', 'right']} regular className={className} float="right" m={[0, 0, `${sizes(-5)} 0 ${sizes(2)} 0`]}>
              {subTitle}
            </Typography>
          </SpacingContainer>
        )}
      </div>
      <div className={requiredFields.message && 'column-md-5 layout-column required-field-message-compact-container'}>
        <div className="required-field-message-compact">
          <Icon name={requiredFields.icon} />
          {requiredFields.message}
        </div>
      </div>
    </div>
    <div className={description && 'layout-row'}>
      <div className={description && 'layout-column'}>
        <Heading as="h3">
          {description}
        </Heading>
      </div>
    </div>
  </div>
);

FormHeadingCompact.defaultProps = {
  requiredFields: { icon: '', text: '' },
  className: '',
  title: '',
  subTitle: '',
};

FormHeadingCompact.propTypes = {
  requiredFields: shape({
    icon: string,
    message: string,
  }),
  title: string,
  subTitle: string,
  description: string.isRequired,
  className: string,
};

export default FormHeadingCompact;
